{
  "version": 1,
  "asset_id": "23176a3f-2b2c-4a51-acd3-cfca9d1ae936",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/23176a3f-2b2c-4a51-acd3-cfca9d1ae936/sylwia-scena-kontrola.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/23176a3f-2b2c-4a51-acd3-cfca9d1ae936/sylwia-scena-kontrola.jpg",
  "original_filename": "sylwia-scena-kontrola.jpg",
  "size": 573150,
  "content_type": "image/jpeg",
  "created_at": "2026-09-14T17:40:12Z"
}
